<app-page-container  [DataTableSchema]="dataTableSchema" [title]="title" 
 [dynamicFormArray]="filterSchema" [props]="props">
</app-page-container>